import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ImageUpload({ value, onChange, label = "Image", testid = "image-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${BACKEND}${data.url}`);
      toast.success("Image uploaded");
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div>
      <label className="label-lux">{label}</label>
      <div className="mt-2 flex items-start gap-3">
        <div className="relative h-20 w-20 shrink-0 rounded-lg border border-white/10 bg-black/40 overflow-hidden flex items-center justify-center">
          {value ? <img src={value} alt="preview" className="h-full w-full object-cover" /> : <Upload size={18} className="text-slate-600" />}
          {value && <button type="button" onClick={() => onChange("")} className="absolute top-0.5 right-0.5 bg-black/70 rounded p-0.5 text-slate-300 hover:text-red-400"><X size={12} /></button>}
        </div>
        <div className="flex-1">
          <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={upload} className="hidden" data-testid={`${testid}-input`} />
          <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="silver-btn !py-2 text-sm" data-testid={`${testid}-btn`}>
            {busy ? <Loader2 className="animate-spin" size={15} /> : <Upload size={15} />} Upload
          </button>
          <input className="input-lux mt-2 text-xs" placeholder="…or paste an image URL" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-url`} />
        </div>
      </div>
    </div>
  );
}
